export default __webpack_public_path__ + "static/media/imagem-modal-renegociacao.a83b091c.png";